<h1 class="default-layout">{{ card.title | translate }}</h1>
@if (kennzahlen) {
  <div
    fxLayout="column"
    ngStyle.gt-lg="max-width: 75%"
    style="margin: 0px"
    >
    <h4>
      {{
      "m2.sprint2.cockpit.card.kennzahlenMethodik.anpassungEffektivePraxis"
      | translate
      }}
    </h4>
    <app-chart-download-button
      (buttonClick)="downloadTable('gewichtungsfaktoren', 0)"
      >
      <span class="title" translate>{{ tableHeaders[0] }}</span>
    </app-chart-download-button>
    <div class="table-wrapper">
      <table class="striped" id="gewichtungsfaktoren">
        <thead>
          <tr>
            <th scope="col" class="no-border"></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.ausbildung" | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.autonomie" | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint5.cockpit.card.kennzahlenMethodik.spezialwissen"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.verantwortung"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.psychosozial"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.körperlich" | translate
              }}
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <br />
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.minimalerGewichtungsfaktor"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.ausbildung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.autonomie }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.methodenwissen }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.verantwortung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.psychosoziales }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.minimalerGewichtungsfaktor.koerperliches }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.maximalerGewichtungsfaktor"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.ausbildung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.autonomie }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.methodenwissen }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.verantwortung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.psychosoziales }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.maximalerGewichtungsfaktor.koerperliches }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.optimalerGewichtungsfaktor"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.ausbildung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.autonomie }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.methodenwissen }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.verantwortung }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.psychosoziales }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.optimalerGewichtungsfaktor.koerperliches }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.optimalerGewichtungsfaktorNormiert"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert.ausbildung
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert.autonomie
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert
              .methodenwissen
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert
              .verantwortung
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert
              .psychosoziales
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorNormiert
              .koerperliches
              }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.optimalerGewichtungsfaktorInProzent"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent.ausbildung
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent.autonomie
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent
              .methodenwissen
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent
              .verantwortung
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent
              .psychosoziales
              }}
            </td>
            <td class="border-bold-right text-align-right">
              {{
              kennzahlen.anpassung.optimalerGewichtungsfaktorInProzent
              .koerperliches
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-chart-download-button
      (buttonClick)="downloadTable('korrelationskoeffizienten', 1)"
      >
      <span class="title" translate>{{ tableHeaders[1] }}</span>
    </app-chart-download-button>
    <div class="table-wrapper">
      <table class="striped" id="korrelationskoeffizienten">
        <thead>
          <tr>
            <th scope="col" class="no-border"></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.header.koeffizient"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.header.minimalerWert"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.header.maximalerWert"
              | translate
              }}
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.header.rang"
              | translate
              }}
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <br />
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.kendallTauB"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.kendallTauB.koeffizient }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.kendallTauB.minimalerWert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.kendallTauB.maximalerWert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.kendallTauB.rang }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizient.pearson"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.pearson.koeffizient }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.pearson.minimalerWert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.pearson.maximalerWert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.anpassung.pearson.rang }}
            </td>
          </tr>
          <tr class="hint">
            <td class="hint" colspan="5">
              @if (prioritaetAlter) {
                <div>
                  {{
                  "m2.sprint4.cockpit.card.kennzahlenMethodik.hinweise-alter-dienstalter"
                  | translate
                  }}
                </div>
              } @else {
                <div>
                  {{
                  "m2.sprint4.cockpit.card.kennzahlenMethodik.hinweise-dienstalter-alter"
                  | translate
                  }}
                </div>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4>
      {{
      "m2.sprint2.cockpit.card.kennzahlenMethodik.testergebnisse" | translate
      }}
    </h4>
    <app-chart-download-button
      (buttonClick)="downloadTable('anzahlRisikopaare', 2)"
      >
      <span class="title" translate>{{ tableHeaders[2] }}</span>
    </app-chart-download-button>
    <div class="table-wrapper">
      <table class="striped" id="anzahlRisikopaare">
        <thead>
          <tr>
            <th scope="col" class="no-border"></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint5.cockpit.card.kennzahlenMethodik.risikopaare.test1"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint5.cockpit.card.kennzahlenMethodik.risikopaare.test2"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint5.cockpit.card.kennzahlenMethodik.risikopaare.test3"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+2"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+3"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test2+3"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.test1+2+3"
                | translate
              }}</span>
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <br />
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.risikopaare.anzahl"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T1 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T2 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T1_T2 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T1_T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T2_T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.anzahlPaare.T1_T2_T3 }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint5.cockpit.card.kennzahlenMethodik.risikopaare.anzahlInProzent"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T1 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T2 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T1_T2 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T1_T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T2_T3 }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.analyse.paareInProzent.T1_T2_T3 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-chart-download-button (buttonClick)="downloadTable('statischeWerte', 3)">
      <span class="title" translate>{{ tableHeaders[3] }}</span>
    </app-chart-download-button>
    <div class="table-wrapper">
      <table class="striped" id="statischeWerte">
        <thead>
          <tr>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.wert"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.definition"
                | translate
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="centered border-bold-left border-bold-right">2</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.1"
              | translate
              }}
            </td>
          </tr>
          <tr>
            <td class="centered border-bold-left border-bold-right">5%</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.2"
              | translate
              }}
            </td>
          </tr>
          <tr>
            <td class="centered border-bold-left border-bold-right">20%</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.3"
              | translate
              }}
            </td>
          </tr>
          <tr>
            <td class="centered border-bold-left border-bold-right">35%</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.4"
              | translate
              }}
            </td>
          </tr>
          <tr>
            <td class="centered border-bold-left border-bold-right">&lt; 5</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.5"
              | translate
              }}
            </td>
          </tr>
          <tr>
            <td class="centered border-bold-left border-bold-right">30</td>
            <td class="border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.statischerWert.6"
              | translate
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-chart-download-button
      (buttonClick)="downloadTable('regressionsergebnisse', 4)"
      >
      <span class="title" translate>{{ tableHeaders[4] }}</span>
    </app-chart-download-button>
    <div class="table-wrapper">
      <table class="striped" id="regressionsergebnisse">
        <thead>
          <tr>
            <th scope="col" class="no-border"></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.konstante"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.funktionswert"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.alter"
                | translate
              }}</span>
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <span class="strong">{{
                "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.dienstjahre"
                | translate
              }}</span>
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
              >
              <br />
            </th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
            <th
              scope="col"
              class="header centered bold border-bold-left border-bold-right"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.koeffizient"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.koeffizient.b }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.koeffizient.funktionswert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.koeffizient.alter }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.koeffizient.dienstjahre }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">
              {{
              "m2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.standardfehler"
              | translate
              }}
            </th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.standardfehler.b }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.standardfehler.funktionswert }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.standardfehler.alter }}
            </td>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.standardfehler.dienstjahre }}
            </td>
          </tr>
          <tr>
            <th
              scope="row"
              class="border-bold-left border-bold-right"
            [innerHTML]="
              'm2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse.r2'
                | translate
            "
            ></th>
            <td class="border-bold-right text-align-right">
              {{ kennzahlen.regressionsberechnung.r2 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-chart-dialog-risikopaare class="pdt-30" class="cockpit-svg-image"></app-chart-dialog-risikopaare>
  </div>
}
